import React, { useState } from "react";
import { Form, Formik, Field, ErrorMessage } from "formik";
import { Col, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import TextError from "../../helpers/FormikHelper/TextError";
import { toast } from 'react-toastify';
import managePagesServices from "../../services/managePages.services";
import { ManagePageSchema } from "../../schema/ManagePagesSchema";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Accordion from 'react-bootstrap/Accordion';
const initialValues = {
    heading: '',
    sectionOneSmallHeadin: '',
    sectionOneParagraph: '',
    sectionOneHeading: '',
    sectionTwoSmallTitile: '',
    sectionTwoTitile: '',
    sectionTwoSmallHeadin: '',
    sectionTwoParagraph: '',
    sectionTwoHeading: '',
    bannerTitile: '',
    bannerText: '',
    file: ''
}

const ManageForm = ({ toggle, isAddMode, getData, selectedRow, pageTitle, pageType, pageUrl }) => {
    const [file, setFile] = useState(selectedRow?.bannerImg);
    function handleChange(e) {
        if (e.target.files.length > 0) {
            setFile(URL.createObjectURL(e.target.files[0]));
        } else {
            setFile('')
        }
    }
    const savedValues = {
        heading: selectedRow?.heading,
        sectionOneSmallHeadin: selectedRow?.sectionOneSmallHeadin,
        sectionOneParagraph: selectedRow?.sectionOneParagraph,
        sectionOneHeading: selectedRow?.sectionOneHeading,
        sectionTwoSmallTitile: selectedRow?.sectionTwoSmallTitile,
        sectionTwoTitile: selectedRow?.sectionTwoTitile,
        sectionTwoSmallHeadin: selectedRow?.sectionTwoSmallHeadin,
        sectionTwoParagraph: selectedRow?.sectionTwoParagraph,
        sectionTwoHeading: selectedRow?.sectionTwoHeading,
        bannerTitle: selectedRow?.bannerTitle,
        bannerText: selectedRow?.bannerText,
        file: ''
    }
    const onSubmit = async (values) => {
        if (isAddMode === 'Add') {
            const result = await managePagesServices.creatApi(values);
            if (result.data.status === true) {
                // actions.resetForm();
                getData()
                toggle()
                toast.success('Record added successfully', { toastId: 'registration_success', autoClose: 3000 });
            } else {
                toast.error(result.data.message, { toastId: 'registration_fail', autoClose: 3000 });
            }
        } else {
            const result = await managePagesServices.updateManagePageContentApi(selectedRow?._id, values)
            if (result.data.status === true) {
                // actions.resetForm();
                getData()
                toggle()
                toast.success('Record updated successfully', { toastId: 'update_success', autoClose: 3000 });
            } else {
                toast.error(result.data.message, { toastId: 'update_fail', autoClose: 3000 });
            }
        }
    }
    return (
        <React.Fragment>
            <Formik
                initialValues={isAddMode === 'Add' ? initialValues : savedValues}
                // validationSchema={ManagePageSchema('add')}
                onSubmit={onSubmit}
                enableReinitialize
            >
                {({ setFieldValue, values }) => (<Form>
                    <ModalHeader toggle={toggle}>
                        <div className="card-title d-flex align-items-center">
                            <div>
                                <i className="bx bxs-user me-1 font-22 text-primary" />
                            </div>
                            <h5 className="mb-0 text-primary">{isAddMode === 'Add' ? 'Add Record' : pageTitle ? pageTitle : 'Manage Page Contents'}</h5>
                        </div>
                    </ModalHeader>
                    <ModalBody className="">
                        <Col md={12}>
                            <div className="row g-3" >

                                {/* <Accordion defaultActiveKey="0"> */}
                                <Accordion>
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>Section One</Accordion.Header>
                                        <Accordion.Body>
                                            {pageUrl === 'home' &&
                                                <div className="col-md-12">
                                                    <label htmlFor="heading" className="form-label">
                                                        Heading
                                                    </label>
                                                    <Field type="text" className="form-control" id="heading" name='heading'
                                                    />
                                                    <ErrorMessage name='heading' component={TextError} />
                                                </div>
                                            }
                                            {(pageUrl === 'about' || pageUrl === 'services' || pageType === 1) &&
                                                <>
                                                    <div className="col-md-12">
                                                        <label htmlFor="bannerTitle" className="form-label">
                                                            Banner Title
                                                        </label>
                                                        <Field type="text" className="form-control" id="bannerTitle" name='bannerTitle'
                                                        />
                                                        <ErrorMessage name='bannerTitle' component={TextError} />
                                                    </div>
                                                    <div className="col-md-12">
                                                        <label htmlFor="bannerTitle" className="form-label">
                                                            Banner Description
                                                        </label>
                                                        <Field type="text" className="form-control" id="bannerText" name='bannerText'
                                                        />
                                                        <ErrorMessage name='bannerText' component={TextError} />
                                                    </div>
                                                    <div className="col-md-12">
                                                        <label htmlFor="file" className="form-label">
                                                            Banner Image
                                                        </label>

                                                        <input id="file" name="file" type="file" onChange={(event) => {
                                                            setFieldValue("file", event.currentTarget.files[0]);
                                                            handleChange(event)
                                                        }} className="form-control" />
                                                        {file === undefined || file === '' ? '' : <img src={file}
                                                            alt={selectedRow?.bannerImg}
                                                            className="img-thumbnail mt-2"
                                                            height={150}
                                                            width={150} />}

                                                    </div>
                                                </>
                                            }
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="1">
                                        <Accordion.Header>Section Two</Accordion.Header>
                                        <Accordion.Body>
                                            <div className="col-md-12">
                                                <label htmlFor="sectionOneSmallHeadin" className="form-label">
                                                    Small Heading
                                                </label>
                                                <Field type="text" className="form-control" id="sectionOneSmallHeadin" name='sectionOneSmallHeadin'
                                                />
                                                <ErrorMessage name='sectionOneSmallHeadin' component={TextError} />
                                            </div>
                                            <div className="col-md-12">
                                                <label htmlFor="sectionOneHeading" className="form-label">
                                                    Heading
                                                </label>
                                                <Field type="text" className="form-control" id="sectionOneHeading" name='sectionOneHeading'
                                                />
                                                <ErrorMessage name='sectionOneHeading' component={TextError} />
                                            </div>
                                            <div className="col-md-12">
                                                <label htmlFor="sectionOneParagraph" className="form-label">
                                                    Paragraph
                                                </label>

                                                <CKEditor
                                                    editor={ClassicEditor}
                                                    data={values.sectionOneParagraph}
                                                    onReady={editor => {
                                                        // You can store the "editor" and use when it is needed.
                                                        console.log('Editor is ready to use!', editor);
                                                    }}
                                                    onChange={(event, editor) => {
                                                        const data = editor.getData();
                                                        console.log({ event, editor, data });
                                                        setFieldValue("sectionOneParagraph", data);
                                                    }}
                                                    onBlur={(event, editor) => {
                                                        console.log('Blur.', editor);
                                                    }}
                                                    onFocus={(event, editor) => {
                                                        console.log('Focus.', editor);
                                                    }}
                                                />
                                                <ErrorMessage name='sectionOneParagraph' component={TextError} />
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    {pageType === 1 &&
                                        <>
                                            <Accordion.Item eventKey="2">
                                                <Accordion.Header>Section Three</Accordion.Header>
                                                <Accordion.Body>
                                                    {pageType === 1 &&
                                                        <>
                                                            <div className="col-md-12">
                                                                <label htmlFor="sectionTwoSmallTitile" className="form-label">
                                                                    Small Titile
                                                                </label>
                                                                <Field type="text" className="form-control" id="sectionTwoSmallTitile" name='sectionTwoSmallTitile'
                                                                />
                                                                <ErrorMessage name='sectionTwoSmallTitile' component={TextError} />
                                                            </div>
                                                            <div className="col-md-12">
                                                                <label htmlFor="sectionTwoTitile" className="form-label">
                                                                    Titile
                                                                </label>
                                                                <Field type="text" className="form-control" id="sectionTwoTitile" name='sectionTwoTitile'
                                                                />
                                                                <ErrorMessage name='sectionTwoSmsectionTwoTitileallHeadin' component={TextError} />
                                                            </div>
                                                        </>
                                                    }
                                                    <div className="col-md-12">
                                                        <label htmlFor="sectionTwoSmallHeadin" className="form-label">
                                                            Small Heading
                                                        </label>
                                                        <Field type="text" className="form-control" id="sectionTwoSmallHeadin" name='sectionTwoSmallHeadin'
                                                        />
                                                        <ErrorMessage name='sectionTwoSmallHeadin' component={TextError} />
                                                    </div>
                                                    <div className="col-md-12">
                                                        <label htmlFor="sectionTwoHeading" className="form-label">
                                                            Heading
                                                        </label>
                                                        <Field type="text" className="form-control" id="sectionTwoHeading" name='sectionTwoHeading'
                                                        />
                                                        <ErrorMessage name='sectionTwoHeading' component={TextError} />
                                                    </div>
                                                    <div className="col-md-12">
                                                        <label htmlFor="sectionTwoParagraph" className="form-label">
                                                            Paragraph
                                                        </label>

                                                        <CKEditor
                                                            editor={ClassicEditor}
                                                            data={values.sectionTwoParagraph}
                                                            onReady={editor => {
                                                                // You can store the "editor" and use when it is needed.
                                                                console.log('Editor is ready to use!', editor);
                                                            }}
                                                            onChange={(event, editor) => {
                                                                const data = editor.getData();
                                                                console.log({ event, editor, data });
                                                                setFieldValue("sectionTwoParagraph", data);
                                                            }}
                                                            onBlur={(event, editor) => {
                                                                console.log('Blur.', editor);
                                                            }}
                                                            onFocus={(event, editor) => {
                                                                console.log('Focus.', editor);
                                                            }}
                                                        />
                                                        <ErrorMessage name='sectionTwoParagraph' component={TextError} />
                                                    </div>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </>
                                    }
                                </Accordion>
                            </div>
                        </Col>
                    </ModalBody>
                    <ModalFooter>
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={toggle}
                        >
                            Close
                        </button>
                        <button type="submit" className="btn btn-primary px-5">
                            {isAddMode === "Add" ? "Save" : "Update"}
                        </button>
                    </ModalFooter>
                </Form>
                )}
            </Formik>
        </React.Fragment>
    );
}

export default ManageForm;